export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["此操作将永久删除该资产"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您确定要继续吗？"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["是"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["取消"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您将不会在列表中看到此资产。"])}
}